import { render, staticRenderFns } from "./uploadXMLFile.vue?vue&type=template&id=0a8dc486&scoped=true"
import script from "./uploadXMLFile.vue?vue&type=script&lang=js"
export * from "./uploadXMLFile.vue?vue&type=script&lang=js"
import style0 from "./uploadXMLFile.vue?vue&type=style&index=0&id=0a8dc486&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8dc486",
  null
  
)

export default component.exports